import { Injectable, Injector } from '@angular/core';
import { VagaModel } from '../models';
import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class VagaService extends BaseCrudService<VagaModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'vaga';
  }

  getAll(): Observable<VagaModel[]> {
    return this
      .httpClient
      .get<VagaModel>(`${this.getApiUrl()}${this.getController()}`, this.getHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
